"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "freeze-overlay" };
const vue_3 = require("vue");
const AlertIcon_vue_1 = __importDefault(require("../view/assets/icons/AlertIcon.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'DashboardFreezeModal',
    setup(__props) {
        const freezeModal = (0, vue_3.ref)(null);
        (0, vue_3.onMounted)(() => {
            freezeModal.value?.focus();
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", {
                    ref_key: "freezeModal",
                    ref: freezeModal,
                    class: "freeze-content",
                    role: "dialog",
                    "aria-modal": "true",
                    "aria-labelledby": "dashboard-freeze-title",
                    tabindex: "-1"
                }, [
                    (0, vue_2.createVNode)(AlertIcon_vue_1.default),
                    _cache[0] || (_cache[0] = (0, vue_2.createElementVNode)("div", {
                        id: "dashboard-freeze-title",
                        class: "freeze-title"
                    }, "アカウントを一時停止しています", -1 /* CACHED */)),
                    _cache[1] || (_cache[1] = (0, vue_2.createElementVNode)("div", {
                        id: "dashboard-freeze-message",
                        class: "freeze-message"
                    }, "ご利用料金のお支払いが確認できないため、現在アカウントを一時停止しています。お支払い状況をご確認のうえ、未払い分のお支払いをお願いいたします。すでにお手続きいただいている場合は、行き違いの可能性もございますので、何卒ご容赦くださいませ。詳細はサポートチャットもしくはお電話にてお問い合わせください。", -1 /* CACHED */))
                ], 512 /* NEED_PATCH */)
            ]));
        };
    }
});
